import React, {useState, useEffect} from 'react';
import {EmailTooltip,AppTooltip} from '../../atoms';
import useCollapse from 'react-collapsed';
import './expand-collapse.scss';


export default function ExpandCollapse (props) {
    const kpisData = props.options;
    const  [styleclass, setClass] = useState('');
    const [kpis, setKpis] = useState([]);
    const [categories, setCategories] = useState([]);
    const [sublevel1, setSublevel1] = useState([]);
    const [kpisublevel1, setkpisublevel1 ] = useState([]);
    const [sublevel2, setSublevel2] = useState([]);
    const [show, showstyle] = useState('');
    const [searchItem, setSearchItem] = useState('');
    const selectedVals = props.list;
    const setSelectedVals = props.setList;
    const blsKPIName = 'Brand Lift';
    useEffect(() => {
        if(props.options.length) {
            setKpis(props.options);
        } 
        
    },[props.options]);
    
    useEffect(() => {
        setKpis(kpis);
        filterItems('kpi_category', 'kpi_subcategory', 'kpi_type', 'kpi_metric');
    },[kpis]);

    useEffect(() => {
        filterHandler('');
    },[selectedVals])


    const filterItems = (k1,k2, k3,k4) => { 
       // if(!kpis.length)  return false;
        let categories =[], sublevel1 = [], sublevel2 = [];
        let category = [];
        let tempCategory;
        if(kpis.length){
        kpis.map((item) => {
            let tempSubCat , tempType;
            for (const i in item) {
                 if(i.toLowerCase() === k1) {
                    tempCategory = item[i];
                    category.push(tempCategory);
                }
                if(i.toLowerCase() === k2) {
                    tempSubCat = item[i];
                    sublevel1.push(tempCategory + ':'+item[i]);
                }
                if(i.toLowerCase() === k3) {
                    tempType = item[i];
                }
                if(i.toLowerCase() === k4 && item.sys_id !== '' && item.is_active) {
                    let finalele = tempType+ '-'+ item[i]
                    sublevel2.push(tempSubCat + ':'+ finalele + ':'+ item.sys_id);
                    // console.log('sys_id: '+item.sys_id);
                }
            }
        })
        
         categories =  category.filter((ele, index) => category.indexOf(ele) === index); // to remove duplicates
    }
        //  console.log('categories '+ categories);
        //  console.log('subcategory - '+ sublevel1);
        //  console.log('subcategory2 - '+ sublevel2);
         setCategories(categories);
         setSublevel1(sublevel1); setkpisublevel1(sublevel1);
         setSublevel2(sublevel2);
    }

    const filteredValues = (item, arr) => {
       const newarr =  arr.filter((ele, index) => arr.indexOf(ele) === index); // to remove duplicates
        const newarrUnique =  newarr.filter((i) => (item.toLowerCase() === i.split(':')[0].toLowerCase())  )
        return newarrUnique;
    }
   
   
    const filterHandler  =  ((keyword) => {
        //  const keyword = k.trim(); 
        if(!keyword.trim()) {
            showstyle('');  setSearchItem(''); 
            return setKpis(props.options);
        }  else {
            showstyle('show'); setSearchItem(keyword);
            setKpis(props.options.filter(item => item.KPI_Metric.toLowerCase().includes(keyword.toLowerCase())))
        }
       // console.log(props.options.filter(item => item.KPI_subcategory.toLowerCase().includes(keyword.toLowerCase())))
    })
    
    const addItem = (event, list, setList) => {
        event.preventDefault();
        event.target.parentElement.classList.add('kpi_selected');
        const checkedItem =  {
            id: event.target.id,
            value: event.currentTarget.attributes.checkval ? event.currentTarget.attributes.checkval.value +':'+event.target.value : event.target.value   
        }
        const checkedList = [];
        checkedList.push(checkedItem);
        setList(checkedList); 
        
    }
    const deleteItem = (event, id, val, list, setList) => { 
        const templist = [...list];
    
        // Filter values and leave value which we need to delete
        const updateList = templist.filter(item => item.id !== id);

        // Update list in state
        setList(updateList);
        
        // let uncheckOption = checkboxOptions.filter(item => item.value === val);
    }

    // Collapseable section definition 
    function Section(props) {
        const config = {
            defaultExpanded: props.defaultExpanded || true,
            collapsedHeight: props.collapsedHeight || 0
        };
        const { getCollapseProps, getToggleProps, isExpanded } = useCollapse(config);
        return (
          <div className="collapsible">
            <div
              className={props.title === blsKPIName ? 'header blsClass' : 'header'}
              {...getToggleProps()}
            >
              <div className="icon">
                <i className={'eva eva-arrow-' + (isExpanded ? 'down' : 'right') + '-outline'}></i>
              </div>
              <div className="title">
                {props.title}
                {props.title === blsKPIName && (
                  <i
                    className="eva eva-info-outline"
                    data-tip={'Brand Lift KPI'}
                    data-for="tool-tip-bls"
                  ></i>
                )}
                <AppTooltip
                  className="c-table-info-icon--tooltip"
                  id="tool-tip-bls"
                  place="bottom"
                />
              </div>
            </div>
            <div {...getCollapseProps()}>
              <div className="content">{props.children}</div>
            </div>
          </div>
        );
    }

    return (
        <div className="expand-collapse-wrapper">
            <div className="top-section">
                <div className="section-header">
                    <h3 className="c-text-heading-3">{props.heading}</h3>
                    <div className="tooltip">
                        <EmailTooltip id={props.classname}  emailToolTip={props.tooltip} />
                    </div>
                </div>
                <div className="selected-list">
                {selectedVals.map(item => {return (
                    // <DisplayTask value= {item.value}  onClick = { () => deleteItem(item.id) } />
                    <div className="selected-item" key={item.id}  
                    onClick = { (e) => deleteItem(e,item.id, item.value,selectedVals, setSelectedVals ) } >
                        <span className="selected-value">  { (item.value).split(':')[1] }</span>
                        <span className="cross"><i className='eva eva-close-outline clear-icon'></i></span>
                    </div>
                    )})
                }
                </div>
            </div>

            <div className="bottom-section">
                <div className="search-field" >
                <i className='eva eva-search-outline search-icon'></i>
                    <input type="text" name="search" 
                    placeholder={props.placeholder} 
                    value ={searchItem}
                    onChange={(e) => filterHandler(e.target.value,e) }  
                    autoComplete="off"/>
                    <button type="button" className={`clear-btn ${show}`} onClick={(e) => filterHandler('') }><i className="eva eva-close-outline clear-icon"></i></button>
                </div>
                <div className="list-items">
                { categories.map((item, index) => ( 
                    <div className="list-kpis" key={`${item}${index}`}>
                        <div className="kpi-category">{ item }</div>  {/* Render Category */}
                        { filteredValues(item, sublevel1).map((a, index) => ( 
                            <ul className="sub-list1"  key={index}>  {/*  Render subcategory expand/collapse */}
                                <li className= "subcategory"  key={`${Math.random()}`}> 
                                    <Section title={a.split(':')[1]} >
                                    <ul> {/* Render last level subcategory */}
                                        { filteredValues(a.split(':')[1], sublevel2).map((b) => (
                                             <li key={`${Math.random()}`} className= {`${styleclass}`}> 
                                             {/* sys_id is in checkval attribute and value= kpiType-kpiMetric from API call of kpis */}
                                                <button id={`kpis${Math.random()}`} className="sub-cat2" 
                                                    onClick= {(e) => {addItem(e,selectedVals,setSelectedVals)} } 
                                                    checkval={b.split(':')[2]}   
                                                    value={b.split(':')[1]}>
                                                     {b.split(':')[1]}
                                                </button>
                                             </li> 
                                        ) ) }
                                    </ul> 
                                    </Section>
                                </li>  
                            </ul>
                        ) ) }
                    </div>  
                ))  
                }
                </div> 
            </div>
        </div> 
    )
}
